import {ShippingInfoModel} from './ShippingInfo.model';
import {PriceSummaryModel} from './PriceSummary.model';
import {ViolationModel} from './Violation.model';
import {AdditionalFeeModel} from './AdditionalFee.model';
import {MinimumOrderAmountModel} from './MinimumOrderAmount.model';
import {EstimateTotalsResponse} from '@wix/auto_sdk_ecom_current-cart';
import {AppliedCouponModel} from './AppliedCoupon.model';
import {toAppliedCouponSDK} from '../utils/coupon';
import {ModelContext} from '../../types/app.types';

export class EstimatedTotalsModel {
  public priceSummary: PriceSummaryModel;
  public shippingInfo: ShippingInfoModel;
  public payNow: PriceSummaryModel;
  public payLater: PriceSummaryModel;
  public additionalFees: AdditionalFeeModel[];
  public violations: ViolationModel[];
  public minimumOrderAmount: MinimumOrderAmountModel;
  public estimatedAmountToPay: number;
  public appliedCoupon: AppliedCouponModel;
  public paymentCurrencyCode: string;

  constructor(params: EstimatedTotalsModel) {
    this.priceSummary = params.priceSummary;
    this.shippingInfo = params.shippingInfo;
    this.payNow = params.payNow;
    this.payLater = params.payLater;
    this.additionalFees = params.additionalFees;
    this.violations = params.violations;
    this.minimumOrderAmount = params.minimumOrderAmount;
    this.estimatedAmountToPay = params.estimatedAmountToPay;
    this.appliedCoupon = params.appliedCoupon;
    this.paymentCurrencyCode = params.paymentCurrencyCode;
  }

  public static fromSDK(estimatedTotals: EstimateTotalsResponse, modelContext: ModelContext): EstimatedTotalsModel {
    return new EstimatedTotalsModel({
      additionalFees: (estimatedTotals?.additionalFees ?? []).map((fee) =>
        AdditionalFeeModel.fromSDK(fee, modelContext)
      ),
      estimatedAmountToPay: Number(
        modelContext.shouldPayWithConvertedCurrency
          ? estimatedTotals.priceSummary.total.convertedAmount
          : estimatedTotals.priceSummary.total.amount
      ),
      minimumOrderAmount: MinimumOrderAmountModel.fromSDK(
        estimatedTotals.calculationErrors.orderValidationErrors,
        modelContext
      ),
      payLater: PriceSummaryModel.fromSDK(estimatedTotals.payLater, modelContext),
      payNow: PriceSummaryModel.fromSDK(estimatedTotals.payNow, modelContext),
      priceSummary: PriceSummaryModel.fromSDK(estimatedTotals.priceSummary, modelContext),
      shippingInfo: estimatedTotals.shippingInfo
        ? ShippingInfoModel.fromSDK(
            estimatedTotals.shippingInfo,
            estimatedTotals?.calculationErrors?.carrierErrors,
            modelContext
          )
        : undefined,
      violations: (estimatedTotals?.violations ?? []).map(ViolationModel.fromSDK),
      appliedCoupon: toAppliedCouponSDK(estimatedTotals.appliedDiscounts),
      paymentCurrencyCode: modelContext.paymentCurrencyCode,
    });
  }
}
